/**
 * Utility functions for managing the API proxy cache
 * This is needed to clear cached route responses when loading saved routes
 */

/**
 * Clear the proxy cache to prevent stale route data from being returned
 * This is especially important when loading saved routes that might have
 * the same coordinates as previously calculated routes with temporary modifications
 */
export const clearProxyCache = async (): Promise<boolean> => {
  try {
    const response = await fetch('/proxy/api/cache/clear', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (response.ok) {
      await response.json();
      return true;
    } else {
      console.warn('⚠️ Failed to clear proxy cache:', response.status, response.statusText);
      return false;
    }
  } catch (error) {
    console.error('❌ Error clearing proxy cache:', error);
    return false;
  }
};
